module.exports = __webpack_public_path__ + "static/img/video_icon4_1.be004ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon4_1.png
// module id = ABPk
// module chunks = 0